import { WIX_DOMAINLESS_IDS_LEGACY, WIX_DOMAINLESS_IDS, } from '../consts/consts';
/**
 * Sanitizes the given URL by leaving only supported query params.
 *
 * @param {String} url original url
 * @param {String} lang value to add to url
 */
export function convertUrlMultilingual(_a) {
    var urlString = _a.urlString, lang = _a.lang, _b = _a.connectedDomainResponse, isConnected = _b.isConnected, missingDomianInfo = _b.hasError;
    try {
        var url_1 = new URL(urlString);
        if (missingDomianInfo) {
            isConnected = WIX_DOMAINLESS_IDS.every(function (domainId) { return !url_1.hostname.includes(domainId); });
        }
        return isConnected
            ? handleUrlWithDomain(url_1, lang)
            : handleUrlWithNoDomain(url_1, lang);
    }
    catch (_c) {
        return typeof urlString === 'string' ? urlString : '';
    }
}
export function convertUrlMultilingualLegacy(urlString, lang) {
    try {
        var url = new URL(urlString);
        return url.hostname.includes(WIX_DOMAINLESS_IDS_LEGACY)
            ? handleUrlWithNoDomain(url, lang)
            : handleUrlWithDomain(url, lang);
    }
    catch (_a) {
        return typeof urlString === 'string' ? urlString : '';
    }
}
function handleUrlWithNoDomain(url, lang) {
    url.searchParams.set('lang', lang);
    return url.href;
}
function handleUrlWithDomain(url, lang) {
    var protocol = url.protocol, host = url.host, pathname = url.pathname, search = url.search, href = url.href;
    return host.includes('www')
        ? href.replace('www', lang)
        : protocol + "//" + lang + "." + host + pathname + search;
}
